import { render, staticRenderFns } from "./hamburger.vue?vue&type=template&id=f89a2512&scoped=true&lang=pug"
import script from "./hamburger.vue?vue&type=script&lang=js"
export * from "./hamburger.vue?vue&type=script&lang=js"
import style0 from "./hamburger.vue?vue&type=style&index=0&id=f89a2512&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89a2512",
  null
  
)

export default component.exports